(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lby-card-info"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lby-card-info')) return;

    class LbyCardInfo extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('[data-lci-add]');
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.add(btn);
          });
        }
        /* keep the card link from firing when the bag link is tapped */
        const link = this.querySelector('a.lci__cart');
        if (link) link.addEventListener('click', (e) => e.stopPropagation());
      }

      async add(btn) {
        const variantId = btn.dataset.lciAdd;
        if (!variantId || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        const status = this.querySelector('.lci__status');

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');
        if (sectionIds.length) body.append('sections', sectionIds.join(','));

        let events = null;
        try { events = await import('@shopify/events'); } catch (err) { events = null; }

        let deferred = null;
        if (events && events.CartLinesUpdateEvent) {
          deferred = events.CartLinesUpdateEvent.createPromise();
          btn.dispatchEvent(new events.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(variantId), quantity: 1 }],
            promise: deferred.promise,
          }));
        }

        try {
          const res = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            body,
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message || 'Could not add to bag');

          const cart = await fetch(this.dataset.cartJsUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());

          if (deferred) {
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'lby-card-info',
                sourceId: this.id,
                itemCount: 1,
                productId: btn.dataset.productId,
                sections: data.sections,
                didError: false,
              },
            });
          } else {
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart } }));
          }

          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (status) status.textContent = 'Added to bag';
          setTimeout(() => btn.classList.remove('is-added'), 1800);

          if (this.dataset.openDrawer === 'true') {
            const drawer = document.getElementById('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              setTimeout(() => { if (!drawer.isOpen) drawer.open(); }, 150);
            } else {
              window.location.href = this.dataset.cartUrl;
            }
          }
        } catch (err) {
          if (deferred) deferred.reject(err);
          btn.classList.remove('is-loading');
          if (status) status.textContent = err.message || 'Could not add to bag';
          if (btn.dataset.url) window.location.href = btn.dataset.url;
        }
      }
    }

    customElements.define('lby-card-info', LbyCardInfo);
  })();
  } catch(e) { console.error(e); }
})();

})();
